import "./styles/theme.css";
import { initTheme } from "./utils/theme.js";
import "./components/app-shell.js";

initTheme();
